import dayjs from 'dayjs'

import { DesktopBundleInfoDTO } from 'sections/PromoSection/pages/AppsPage/types'
import convertKeysToCamelCase from 'utils/helpers/convertKeysToCamelCase'
import { uuid4 } from 'utils/helpers/uuid4'

import { appConfig } from '../config/environment/appConfig'
import { SECTIONS_IDS } from '../shared/constants/values'
import { FileUploadDTO, SectionsResponseType } from '../shared/types/types'
import { PromoSiteContactRequest, SectionsDTO } from '../types/types'
import { getQueryUrl } from './utils/getQueryUrl'
import { FileUploadRequest } from './FileService'
import { HttpService } from './HttpService'

HttpService.setHeaders({
  Accept: 'application/json, text/plain, */*',
  'Content-Type': 'application/json',
})

const apiService = new HttpService(appConfig.API_SHARD_URL)
const promoService = new HttpService(appConfig.PROMO_URL)
const metricsService = new HttpService(appConfig.METRICS_URL)
const appMgmtService = new HttpService(appConfig.APP_MGMT_URL)
const apiDiscoveryService = new HttpService(appConfig.DISCOVERY_URL)

const requests = {
  updateSections: async (patch: SectionsDTO) => {
    const str = JSON.stringify(patch)

    const result = await promoService.post<SectionsResponseType>('content/admin/promo-content-sections/v2', {
      body: { data: str, id: 3 },
      requestFromPromo: true,
    })

    return result
  },

  getSections: async () => {
    const result = await promoService.post<SectionsResponseType>('content/promo-content-sections/v2', {
      body: { ids: SECTIONS_IDS },
      requestFromPromo: true,
    })
    return result
  },

  fileUpload: async (data: FileUploadRequest, requestFromPromo: boolean = false): Promise<FileUploadDTO> => {
    const result = await apiService.post<FileUploadDTO>('api/v2/file/upload', {
      body: {
        chunk_num: data.chunkNum,
        entity_type: data.entityType,
        entity_id: data.entityId,
        total_size: data.totalSize,
        chunk: data.chunk,
        uuid: data.uuid,
      },
      requestFromPromo,
    })

    return convertKeysToCamelCase(result)
  },

  addReview: async (data: PromoSiteContactRequest) => {
    await apiDiscoveryService.post('api/v4/ticket/promo-site-contact', {
      body: data,
    })
  },

  sendAppMetrics: async () => {
    const date = new Date()
    const isoString = date.toISOString()
    const userAgent = navigator.userAgent

    await metricsService.post('api/v1/events', {
      body: [
        {
          reqid: uuid4(),
          timestamp: isoString,
          kind: 'regular',
          type: 'USER_ACTION',
          tags: ['download', 'events', 'promo'],
          extra_data: { 'user-agent': userAgent },
        },
      ],
    })
  },

  getDesktopBundleLink: async (platform: 'windows' | 'linux'): Promise<DesktopBundleInfoDTO> => {
    const queryUrl = getQueryUrl({
      is_promo: true,
    })
    return await appMgmtService.get(`api/v2/update-by-pickpoint?${queryUrl}`, {
      headers: { 'x-os-type': platform, 'x-timestamp': dayjs().format('YYYY-MM-DD HH:mm:ss') },
      disableToken: true,
    })
  },
}

export default {
  requests,
}
